import { onScrollTo } from './../utility/onScrollTo'

export default function imageFadeIn() {
	onScrollTo('.onscroll--fadein', (el) => el.classList.add('animate'), { offset: 200 })
}